<div class="content-container">
    <!-- Perfil Super Admin Retail Group kpis -->
    <div class="row metrics-row" *ngIf="helperService.user.role.roleId === 4">
        <div class="contentcards" *ngFor="let item of dataKPI$ | async">
            <div class="loading-container">
               
                <section *ngIf="isLoading" style="margin: auto">
                    <div  class="pulsing">
                      <mat-spinner [diameter]="50" ></mat-spinner>
                    </div>
                    <p class="pulsing">{{"Loading" | translate }}</p>
                  </section>    
            </div>
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons">
                            <i class="bi bi-person-check"></i>
                        </div>
                        <mat-card-title class="Asistencia"> {{ "Assistance" | translate}} </mat-card-title>
                        <mat-card-subtitle>{{ item.promedioAsistidasCompanyIncadea }}% </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons2">
                            <i class="bi bi-person-x"></i>
                        </div>
                        <mat-card-title class="Citascanceladas"> {{ "NoShow" | translate}} </mat-card-title>
                        <mat-card-subtitle> {{item.promedioNoShowCompanyIncadea}}% </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons3">
                            <i class="bi bi-calendar2-x"></i>
                        </div>
                        <mat-card-title class="Inasistencia"> {{ "CanceledAppointments" | translate }} </mat-card-title>
                        <mat-card-subtitle> {{item.promedioCancelCompanyIncadea}}% </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
        </div>
    </div>
    <!--Perfil Contact Center Advisor kpis-->
    <div class="row metrics-row" *ngIf="helperService.user.role.roleId === 3">
        <div class="contentcards" *ngFor="let item of dataKPI$ | async">
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons">
                            <i class="bi bi-person-x"></i>
                        </div>
                        <mat-card-title class="Asistencia"> {{ "NoShow" | translate}} </mat-card-title>
                        <mat-card-subtitle> {{ item.noShowContactCenterIncadea }} </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header class="card-fail">
                        <div mat-card-avatar class="metric-icons2">
                            <i class="bi bi-calendar2-x"></i>
                        </div>
                        <mat-card-title class="Citascanceladas"> {{ "CanceledAppointments" | translate }} </mat-card-title>
                        <mat-card-subtitle> {{ item.cancelContactCenterIncadea }} </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-lg-4">
                <mat-card>
                    <mat-card-header>
                        <div mat-card-avatar class="metric-icons3">
                            <i class="bi bi-calendar3-week"></i>
                        </div>
                        <mat-card-title class="ContactCenter"> {{ "ContactCenterParticipation" | translate }} </mat-card-title>
                        <mat-card-subtitle> {{ item.participacionContactCenterIncadea }}% </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
        </div>
    </div>
    <div class="row widget-calendar" *ngIf="helperService.user.role.roleId  === 3">
        <div class="widgets-container" [ngClass]="calendarGrid">
            <mat-card
                [ngClass]="{'widgets calendar-widget':isChartExpanded,'widgets calendar-widget2':!isChartExpanded}">
                <app-i-calendar [years]="years" [isCalendarCollapsed]="isChartExpanded"></app-i-calendar>

                <div class="txtmonth"
                    *ngIf="isChartExpanded"> {{years[selectedMonth - 1] | translate | uppercase}}
                </div>
                <div class="txtmycalendar"
                    *ngIf="isChartExpanded"> {{ "MyCalendar" | translate}}
                </div>
                
            </mat-card>
        </div>
        <div class="widgets-container" [ngClass]="chartGrid" >
            <mat-card class="widgets">
                
                <app-i-overall-summary
                    (onToggleExpandCollapseChart)="expandCollapseChart($event)"></app-i-overall-summary>
                    
            </mat-card>
        </div>
    </div>
    <div class="widgets-container retail" [ngClass]="chartGrid2" *ngIf="helperService.user.role.roleId === 4">
        <mat-card class="widgets">

            <app-i-overall-summary
                (onToggleExpandCollapseChart)="expandCollapseChart($event)"></app-i-overall-summary>
        
        </mat-card>
    </div>
</div>
